<template>
    <div>
        <v-form-item
            v-if="boxOptions && boxOptions.length > 1"
            name="replyType"
            label="消息类型"
        >
            <v-card-picker
                :options="cardOptions"
                v-model="replyType"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <div class="card-item-inner">
                        <v-icon
                            :name="props.item.icon"
                            remote
                        />
                        <span>{{ props.item.text }}</span>
                    </div>
                </template>
            </v-card-picker>
        </v-form-item>

        <reply-txt
            v-if="replyType === replyTxtType && boxOptions.indexOf(replyType) > -1"
            v-model="replyTxt"
            @error="(msg)=>handlerError(msg, replyTxtType)"
        />
        <reply-img
            v-if="replyType === replyImgType && boxOptions.indexOf(replyType) > -1"
            v-model="replyImg"
            @error="(msg)=>handlerError(msg, replyImgType)"
        />
        <reply-img-txt
            v-if="replyType === replyImgTxtType && boxOptions.indexOf(replyType) > -1"
            v-model="replyImgTxt"
            @error="(msg)=>handlerError(msg, replyImgTxtType)"
        />
        <reply-applet-plugin
            v-if="replyType === replyAppletPluginType && boxOptions.indexOf(replyType) > -1"
            v-model="replyAppletPlugin"
            @error="(msg)=>handlerError(msg, replyAppletPluginType)"
        />
    </div>
</template>

<script>
import ReplyTxt from './reply-txt';
import ReplyImg from './reply-img';
import ReplyImgTxt from './reply-img-txt';
import ReplyAppletPlugin from './reply-applet-plugin';
import ReplyLoading from './reply-pop/reply-loading';

import { replyTxtType, replyImgType, replyImgTxtType, replyAppletPluginType } from './config/index';

export default {
    name: 'ReplyBox',
    components: {
        ReplyTxt,
        ReplyImg,
        ReplyImgTxt,
        ReplyAppletPlugin,
        ReplyLoading,
    },
    props: {
        reply: {
            type: Object,
            default: () => {},
        },
        boxOptions: {
            type: Array,
            default: () => [replyTxtType, replyImgType, replyImgTxtType, replyAppletPluginType],
        },
        index: {
            type: Number | String,
            default: '',
        },
    },
    data() {
        return {
            replyTxtType,
            replyImgType,
            replyImgTxtType,
            replyAppletPluginType,
            // 默认选择类型
            replyType: '',

            // 输入的内容
            replyTxt: null,
            replyImg: null,
            replyImgTxt: null,
            replyAppletPlugin: null,

            innerError: {},
        };
    },
    computed: {
        cardOptions() {
            const rs = [];

            if (this.boxOptions.includes(replyTxtType)) {
                rs.push({
                    text: '文字消息',
                    value: replyTxtType,
                    icon: 'basic_text_line',
                });
            }

            if (this.boxOptions.includes(replyImgType)) {
                rs.push({
                    text: '图片消息',
                    value: replyImgType,
                    icon: 'basic_picture_line',
                });
            }

            if (this.boxOptions.includes(replyImgTxtType)) {
                rs.push({
                    text: '图文消息',
                    value: replyImgTxtType,
                    icon: 'basic_picture_text_line',
                });
            }

            if (this.boxOptions.includes(replyAppletPluginType)) {
                rs.push({
                    text: '小程序卡片',
                    value: replyAppletPluginType,
                    icon: 'app_miniprogram_line',
                });
            }

            return rs;
        },
    },
    watch: {
        reply() {
            this.initData();
        },

        replyType() {
            this.conbinReplyMsg();
        },
        replyTxt() {
            this.conbinReplyMsg();
        },
        replyImg() {
            this.conbinReplyMsg();
        },
        replyImgTxt() {
            this.conbinReplyMsg();
        },
        replyAppletPlugin() {
            this.conbinReplyMsg();
        },
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            const { replyType = replyTxtType, ...otherData } = this.reply;
            // 如果不在可用列表中，就使用第一个
            this.replyType = replyType;
            if (this.boxOptions.indexOf(replyType) === -1) {
                this.replyType = this.boxOptions[0];
                console.warn('[replyType] not support', replyType);
            }

            switch (replyType) {
            case replyTxtType:
                this.replyTxt = { ...otherData };
                break;
            case replyImgType:
                this.replyImg = { ...otherData };
                break;
            case replyImgTxtType:
                this.replyImgTxt = { ...otherData };
                break;
            case replyAppletPluginType:
                this.replyAppletPlugin = { ...otherData };
                break;
            }
        },
        conbinReplyMsg() {
            console.log('reply', this.replyType);
            let replyCnt;
            switch (this.replyType) {
            case replyTxtType:
                replyCnt = { ...this.replyTxt };
                break;
            case replyImgType:
                replyCnt = { ...this.replyImg };
                break;
            case replyImgTxtType:
                replyCnt = { ...this.replyImgTxt };
                break;
            case replyAppletPluginType:
                replyCnt = { ...this.replyAppletPlugin };
                break;
            }

            replyCnt.replyType = this.replyType;

            if (JSON.stringify(replyCnt) === JSON.stringify(this.reply)) {
                // 数据未变化时，不更新，防止死循环
                console.log('[conbinReplyMsg] not cahnge');
                return;
            }

            this.$emit('change', replyCnt);
        },

        /** 错误处理 */
        handlerError(msg, type) {
            // 记录所有错误数据
            this.innerError[type] = msg;
            // 抛出当前选中类型的错误。
            this.$emit('error', this.innerError[this.replyType]);
        }
    },
};
</script>

<style lang="less" scoped>
.card-item-inner{
    display: flex;
    align-items: center;

    .v-icon{
        margin-right: 4px;
    }
}
</style>
